import type { GrupoDaNotificacao } from '@crm/shared'

/**
 * As três marcas de aviso (ADR 0035), desenhadas pelo Mike: o "!" vermelho,
 * o triângulo amarelo e a bolinha verde.
 *
 * Um desenho só para o sistema todo: na borda da tela elas contam as
 * notificações, e na aba Avisos dizem a gravidade. O mesmo símbolo quer dizer
 * a mesma coisa nos dois lugares.
 *
 * A cor mora no símbolo, e não no fundo da peça: fundo vermelho fixo na borda
 * competiria o dia inteiro com a conversa que se lê ao lado.
 */
export type Marca = 'critico' | 'atencao' | 'informa'

export const MARCA_DO_GRUPO: Record<GrupoDaNotificacao, Marca> = {
  cliente: 'critico',
  acao: 'atencao',
  informa: 'informa',
}

export function SimboloDoAviso({ marca, className }: { marca: Marca; className?: string }) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" className={className}>
      {marca === 'critico' ? (
        <>
          <circle cx="10" cy="10" r="9" className="fill-red-600" />
          <path d="M10 5.2v6" stroke="white" strokeWidth="2.2" strokeLinecap="round" />
          <circle cx="10" cy="14.6" r="1.3" fill="white" />
        </>
      ) : marca === 'atencao' ? (
        <>
          <path
            d="M10 1.8 19 17.4a1 1 0 0 1-.87 1.5H1.87a1 1 0 0 1-.87-1.5Z"
            className="fill-amber-400 stroke-amber-500"
            strokeWidth="1"
            strokeLinejoin="round"
          />
          <path d="M10 7.2v5" stroke="#78350f" strokeWidth="2" strokeLinecap="round" />
          <circle cx="10" cy="15.4" r="1.15" fill="#78350f" />
        </>
      ) : (
        <circle cx="10" cy="10" r="6" className="fill-green-500 stroke-green-600" strokeWidth="1" />
      )}
    </svg>
  )
}
